import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";

import walmartClassicLogo from "../../../images/walmartHeader/classic@3x.png";
import samsClubLogo from "../../../images/walmartHeader/sam@3x.png";
import walmartGtsLogo from "../../../images/walmartHeader/walmartGts@3x.png";
import { THEME_GLOBAL_TECHNOLOGY, THEME_SAM_CLUB } from "../../constants";
import { getSurvey } from "../../../services/api";
import { useTranslation } from "react-i18next";

function SurveyAlreadyTakenState(props) {
  const { t } = useTranslation("surveyTaker");

  const theme = useTheme();
  const styles = useStyles({ theme });
  const [surveyTheme, setSurveyTheme] = useState(null);

  useEffect(() => {
    (async () => {
      if (props.surveyId && !props.campaignDetails?.campaignID?.length > 0) {
        const { thirdPartySettings } = await getSurvey(props.surveyId);
        if (thirdPartySettings && thirdPartySettings.theme) {
          setSurveyTheme(thirdPartySettings.theme);
        }
      }
    })();
  }, []);

  const getImageBasedOnTheme = (themeName) => {
    switch (themeName) {
      case THEME_GLOBAL_TECHNOLOGY:
        return walmartGtsLogo;
      case THEME_SAM_CLUB:
        return samsClubLogo;
      default:
        return walmartClassicLogo;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.surveyTheme}>
        {surveyTheme === null ? null : (
          <img src={getImageBasedOnTheme(surveyTheme)} />
        )}
      </div>
      <span className={styles.title}>
        {" "}
        {t("surveyTaker:thankYouForFeedback")}{" "}
      </span>
      <span className={styles.description}>
        {" "}
        {t("surveyTaker:surveyAlreadyTaken")}{" "}
      </span>
    </div>
  );
}

export default SurveyAlreadyTakenState;
